export default __webpack_public_path__ + "static/media/stories-icon-1.afa1cda7.svg";